import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useTextInput, { TextInput } from "@/components/form/text-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S08 = (props) => {
    const caseDetails = useRadioInput({
        name: "sale[case][claim][details]",
        label: "Hva gjelder saken?",
        tooltip: "Du kan velge flere alternativer.",
        options: {
            data: [
                { label: "Dårligere stand enn forventet", value: "WORSE_THAN_EXPECTED" },
                { label: "Det ble gitt uriktige opplysninger ved kjøpet", value: "MISLEADING_INFORMATION" },
                { label: "Selger har tilbakeholdt informasjon som selger visste eller burde hatt kunnskap om", value: "WITHHELD_INFORMATION" },
                { label: "Det ble ikke levert med avtalt utstyr", value: "MISSING_EQUIPMENT" },
                { label: "Annet", value: "OTHER" },
            ],
        },
        multiple: true,
        required: false,
        ...props,
    })

    const text = useTextInput({
        name: "sale[case][claim][description]",
        placeholder: "Hva annet gjelder det?",
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om problemstillingen">
            <div className="group--flex gg-3">
                <RadioInput {...caseDetails.props}/>
            </div>

            { caseDetails.is("OTHER") && <TextInput {...text.props} className="mt-4"/> }
        </Wrapper>
    );
};

export default S08;
